import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { getCoursesForStudentRequest } from './request.get-all.student.js';
import { getCoursesForTeacherRequest } from './request.get-all.teacher.js';

const getAllCoursesQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 15 * SECONDS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["course-builder/get-all-courses", input.user?.id],
  queryFn: input => {
    switch (input.user?.role) {
      case "student":
        return getCoursesForStudentRequest(input.user.id);
      case "teacher":
        return getCoursesForTeacherRequest(input.user);
      default:
        return [];
    }
  },
  useQueryInput(queryFactory) {
    const user = useUserIdentityState(state => state.user);
    return queryFactory({
      user
    });
  }
});

export { getAllCoursesQuery };
//# sourceMappingURL=query.get-all.js.map
